import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polygon
    {...props}
    points="47.66 24.88 47.66 47.63 25.85 47.72 22.21 44.63 22 39.07 11.76 29.13 41.9 18.25 47.66 24.88"
  />
);

export let ArtworkGodzilla = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.godzilla}
    renderShadow={renderShadow}
  >
    <g>
      <path
        style={{ fill: '#9c545a' }}
        d="M15.9,18.98c.86-.16,1.74-.03,2.61.09,1.45.21,2.93.43,4.25,1.06.49.23.97.54,1.27.99.05.08.1.17.1.27,0,.12-.09.21-.17.29-.96,1-3.07,2.18-4.07,3.14.54-1.75-.34-3.64-3.14-3.8-1.4-.08-1.04-.77-2.37-1.22.43-.42.92-.71,1.52-.82Z"
      />
      <path
        style={{
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          fill: '#fff9ed',
          stroke: '#fff9ed',
          strokeWidth: 0.25,
        }}
        d="M9.75,22.49s.14-.87.03-1.3l.9,1.29s.15-.79.1-1.19c.09.4.56,1.07.56,1.07,0,0,.21-.69.22-1.05.14.41.63,1.14.63,1.14,0,0,.18-.72.16-1.09.1.33.46.94.46.94,0,0,.35-.57.38-.9.13.34.51.95.51.95l.06-1.04c.19.33.66.93.66.93,0,0,.31-.6.38-.93.12.39.52.83.52.83,0,0,.17-.68.16-1.1.23.27.54.91.54.91,0,0,.41-.64.53-1l.45.91s.27-.7.41-1.05c.02-.06.05-.13.03-.19-.03-.08-.11-.12-.2-.13-.14-.03-.29-.03-.44-.03-2.04.03-4.09.06-6.13.1-.47,0-1.33-.11-1.53.46-.08.23.02.48.11.69.05.11.51.78.51.78Z"
      />
      <path
        style={{
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          fill: '#fff9ed',
          stroke: '#fff9ed',
          strokeWidth: 0.25,
        }}
        d="M11.71,25.92c-.12-.36.03-.79.35-1.01.04.35.17.7.36,1l.28-.99c.06.41.13.84.38,1.17-.05-.39,0-.8.16-1.16.12.34.33.64.6.87-.03-.3,0-.61.1-.9.15.38.41.72.74.97-.04-.36,0-.73.1-1.07.09.36.3.69.6.92-.05-.31-.05-.62-.02-.93.12.39.38.73.72.96-.12-.31-.16-.66-.12-.99.25.32.54.6.86.85-.1-.3-.16-.62-.17-.94.28.34.66.59,1.09.71-.05-.31-.06-.63-.04-.95.22.17.46.3.72.38l-.04-.66c.29.17.63.26.97.26.03.36-.13.71-.36.98-.5.58-1.29.82-2.04.95-1.25.21-2.53.21-3.8.17-.46-.02-.92-.04-1.35-.19"
      />
      <path
        style={{ fill: '#88867a' }}
        d="M18.03,27.25c2.04,2.25,3.73,4.83,4.98,7.59.2.45.4.92.75,1.27.32.32.75.52,1.17.69,2.39.99,4.99,1.48,7.58,1.42.51-.01,1.04-.05,1.47-.31.39-.23.67-.63,1.09-.79.27-.1.57-.1.82-.24.19-.1.33-.27.45-.44,1.49-1.98,2.12-4.63,1.49-7.03s-2.55-4.45-4.95-5.07c-1.08-.28-2.2-.27-3.31-.3-1.88-.05-3.77-.21-5.64.04s-3.75.93-5.03,2.3"
      />
      <path
        style={{
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: '#737167',
          strokeWidth: 0.75,
          fill: '#88867a',
        }}
        d="M19.17,28.38c-1.44.06-2.89.22-3.91.5-.82.23-1.66.53-2.51.44-.85-.09-2.26-2.67-1.87-3.01.38-.34.94-.39,1.45-.42,1.31-.07,2.62-.06,3.93-.21,4.37-.51,6.06-4.01,5.19-4.49-.87-.49-2.81-.65-3.76-.39-2.99.82-6.18.88-9.2.19-.86-.2-1.95-.65-1.89-1.53.1-1.44,1.24-2.73,2.6-2.94.52-.08,3.32-.27,3.8-.49.42-.2.73-.81,1.07-1.14,1.87-1.83,6.09-2.09,8.64-2.14.35,0,.73,0,1.02.2.29.21.43.7.17.95,1.26,0,2.53-.41,3.56-1.17.1.33.2.66.29.99.44-.04,1.35.18,2.5.55h.01c.33,0,.66-.06.97-.19.12-.06.23-.12.31-.23.06-.09.08-.2.1-.31.08-.4.1-.81.06-1.22.45.16.82.55.94,1.02.35-.61.83-1.14,1.41-1.53-.15.67-.3,1.34-.45,2.01.47.11.98.04,1.4-.19-.23.36-.46.72-.69,1.07-.17.27-.36.58-.42.89.7.27,1.4.55,2.07.83.48-.04.92-.29,1.28-.61.38-.34.68-.76.97-1.18-.04.38-.07.77.02,1.14.1.37.37.72.75.8.23.05.47-.01.69-.1.88-.34,1.52-1.09,2.13-1.81.12-.15.25-.31.33-.48.12.64.07,1.32-.16,1.94-.03.09-.06.19-.02.27.03.08.11.12.19.16.22.1.44.21.67.31-.32.39-.67.74-1.07,1.05.18.3.48.52.81.6-.35.2-.68.44-.98.71-.14.14-.28.28-.35.46-.1.25-.04.54.03.8.25.9.7,1.75,1.3,2.46h-.01c.27.21.54.41.82.61-.48.25-.96.51-1.45.76,1.17,3.55.01,7.54-1.93,10.68-3.68,5.95-10.24,9.8-16.96,9.96-.19,0-.4,0-.55-.12-.22-.17-.24-.49-.26-.77-.25-5.32.5-12.14-3.37-15.55l.33-.13c1.36-.05,2.72-.01,3.7.11.56.07,1.84-.11,2.31-.42.32-.22,1.66-2.16,1.76-2.64"
      />
      <path
        style={{ fill: '#afb3a8' }}
        d="M28.31,31.84c-.12-.17-.24-.34-.36-.5-.43-.55-.9-1.09-1.52-1.41-.7-.36-5.08-1.12-5.17-.02-.06.68.79,1.93,1,2.7,2.04-.06,4.05-.41,6.06-.78Z"
      />
      <path
        style={{ fill: '#afb3a8' }}
        d="M22.8,35.9c2.58-.01,5.15-.13,7.72-.26-.24-.57-.51-1.13-.82-1.67-.24-.43-.5-.84-.77-1.25-2.14.39-4.27.8-6.44.89.01.07.03.14.04.2.11.69.2,1.39.27,2.08Z"
      />
      <path
        style={{ fill: '#afb3a8' }}
        d="M23,41.28c-.02.5-.04,1,.09,1.48.12.49.43.96.89,1.16.34.14.72.13,1.08.09,1.46-.15,4.24-.79,5.46-1.61.41-.28.46-.92.45-1.22-2.62.19-5.37.36-7.97.11Z"
      />
      <path
        style={{ fill: '#afb3a8' }}
        d="M23,40.28c2.71.29,5.44.09,8.17-.12.02-.1.04-.2.05-.31.14-1.09-.01-2.18-.34-3.24-2.66.13-5.33.26-7.99.27.09,1.13.12,2.26.12,3.39Z"
      />
      <path
        style={{ fill: 'none', stroke: '#737167', strokeWidth: 0.75 }}
        d="M28.27,28.79c1.39,1.39,2.43,3.09,3.36,4.81.55,1.01,1.07,2.04,1.43,3.13.26.79.44,1.61.61,2.43"
      />
      <path
        style={{ fill: 'none', stroke: '#737167', strokeWidth: 0.75 }}
        d="M29.12,23.07c2.11,1.45,3.8,3.36,5.37,5.32.92,1.15,1.8,2.32,2.49,3.61.5.94.88,1.92,1.27,2.9"
      />
      <path
        style={{ fill: 'none', stroke: '#737167', strokeWidth: 0.75 }}
        d="M15.12,16.15c1.26-.15,2.44-.69,3.64-1.11s2.52-.7,3.73-.33"
      />
      <path
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: '#737167',
          strokeWidth: 0.75,
        }}
        d="M30.52,18.61c1.46.93,3.26.5,4.42,0-.48.76-.53,1.74-.14,2.54.75-.06,1.49-.21,2.19-.45-.53.28-.99,1.03-.87,1.6.1.46.49.39.96.47s1.01.11,1.37.42c-.12.52-.23,1.04-.35,1.56-.04.16-.07.33,0,.49.07.17.25.26.42.35.58.29,1.19.55,1.8.77-.36.19-.35.68-.29,1.07.11.66.21,1.33.32,1.99"
      />
    </g>
  </AvatarArtwork>
);
